module.exports = __webpack_public_path__ + "static/media/room-1.7fd02213.jpeg";